import { Popup, Button, Form, Input, List, Toast, Dialog } from 'antd-mobile'
import { useEffect, useState } from 'react'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import format from 'date-fns/format'
import { getMemberManagerList } from '@api/agile.api';
import './index.css'
import { CameraRpApi } from '@api/camera-rp.api'
import { RP } from '@api/types/resource-plan'
type MyForm = { _id: string, companyId: string, faceEntityId: string, accepted?: boolean, name: string, company: string, project: string, duration: string }

export default function MyDispatch(props: any) {
  const [dispatch, setDp] = useState<RP.Domains.DispatchExt>()
  const [form] = Form.useForm<MyForm>();
  const [dpList, setDpList] = useState<RP.Domains.DispatchExt[]>([])
  const [showPopup, setPopup] = useState<boolean>(false)
  const [projectManager, setManager] = useState<{ name?: string, mobile?: string }>({})

  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    CameraRpApi.getDispatch({ id: query.get('id') as string }).then(res => {
      setDp(res.data)
    })
  }, [props.location.search])

  useEffect(() => {
    if (!dispatch) return
    const formData = {
      _id: dispatch._id,
      companyId: dispatch.companyId,
      faceEntityId: dispatch.faceEntityId,
      accepted: dispatch.accepted,
      name: dispatch.faceInfo.name,
      company: dispatch.companyInfo.name,
      project: dispatch.projectInfo.name,
      duration: [dispatch.planStart, dispatch.planEnd].filter(x => !!x).map(x => format(new Date(x as string), 'M月d日')).join('~') + ` (${getDuration(dispatch)}天)`
    }

    form.setFieldsValue(formData)

    if (dispatch.projectInfo.projectManagerId) {
      getMemberManagerList({ managerIdList: [dispatch.projectInfo.projectManagerId] }).then(managerList => {
        const manager = managerList[0] || {}
        setManager({ name: manager.nickName || '-', mobile: manager.mobile })
      })
    } else {
      form.setFieldsValue(formData)
    }

  }, [dispatch, form])

  useEffect(() => {
    if (!dispatch?.companyId || !dispatch.faceEntityId) return
    // getDpList({companyId:dispatch?.companyId,faceEntityId:dispatch?.faceEntityId})
    CameraRpApi.searchDpByPerson({
      companyId: dispatch.companyId,
      faceEntityId: dispatch.faceEntityId,
      status: 'assigned',
      extended: true,
      accepted: 'pending',
      fromDate: new Date()
    }).then(res => {
      setDpList(res.data.filter(x => !x.actualStart && !x.acceptedAt))
    })
  }, [dispatch?.faceEntityId, dispatch?.companyId, dispatch?._id])

  const getDuration = (dp: RP.Domains.Dispatch) => {
    return differenceInCalendarDays(new Date(dp.planEnd || ''), new Date(dp.planStart || '')) + 1
  }

  const confirm = async (accepted: boolean) => {
    const result = await Dialog.confirm({
      content: `确定要 【${accepted ? '接受' : '拒绝'}】 这个派工?`,
    })
    if (result) {
      await CameraRpApi.accept({
        _id: form.getFieldValue('_id'),
        companyId: form.getFieldValue('companyId'),
        faceEntityId: form.getFieldValue('faceEntityId'),
        accepted
      })

      if (dispatch) dispatch.accepted = accepted

      setDpList(dpList.filter(x => x._id !== form.getFieldValue('_id')))

      Toast.show({ content: '操作过成功', position: 'top' })
    }
  }

  return (
    <div className='my-dp-body'>
      <Form
        form={form}
        className='form'
        name='form'
        footer={
          typeof (dispatch?.accepted) === 'boolean' ?
            <div className='form-footer'>
              {
                dispatch.accepted ? <span style={{ color: 'var(--adm-color-success' }}>已接收</span> : <span style={{ color: 'var(--adm-color-danger' }}>已拒绝</span>}</div>
            :
            <div className='form-footer' >
              <Button className='reject-btn' type='submit' size='middle' onClick={() => { confirm(false) }}>拒绝</Button>
              <Button className='accept-btn' type='submit' color='primary' size='middle' onClick={() => { confirm(true) }}>
                接受
              </Button>
            </div>
        }
      >
        <Form.Header>
          <div className='form-header'>
            <div className='form-header-left'>{dispatch?.faceInfo.name}的派工信息</div>
            <>
              {dpList.length > 0 ? <div className='form-header-right' style={{ color: 'var(--adm-color-primary)' }} onClick={() => { setPopup(true) }}>共{`${dpList.length}个待确认的派工`}</div> : null}
            </>

          </div>
        </Form.Header>

        <Form.Item name='project' label='工地' ><Input readOnly /></Form.Item>
        <Form.Item>
          <div className='manager'>
            <span style={{ marginRight: '10px' }}>工地负责人:</span>
            <span style={{ marginRight: '10px' }}>{projectManager.name}</span>
            {projectManager.mobile ? <a href={`tel:${projectManager.mobile}`}>{projectManager.mobile}</a> : null}
          </div>
        </Form.Item>
        <Form.Item name='duration' label='工期' ><Input placeholder='工期' /></Form.Item>
        <Form.Item name='company' label='公司' ><Input readOnly /></Form.Item>
      </Form>
      <Popup
        visible={showPopup}
        showCloseButton
        onClose={() => {
          setPopup(false)
        }}
      >
        <div
          style={{ height: 'calc(100vh * 0.6)', overflowY: 'scroll', padding: '20px' }}
        >
          <List header={`共${dpList.length}个待确认的派工列表`}
            className='list'
          >
            {dpList.map(dp => (
              <List.Item
                key={dp._id}
                extra={
                  <>
                    <span>{getDuration(dp)}</span>
                    <span>天</span>
                  </>
                }
                description={
                  <>
                    <span>{format(new Date(dp.planStart || ''), 'M月d日')}</span>
                    <span>~</span>
                    <span>{format(new Date(dp.planEnd || ''), 'M月d日')}</span>
                  </>
                }
                onClick={async () => {
                  setDp(dp)
                  setPopup(false)
                }}
              >
                {dp.projectInfo.name}
              </List.Item>
            ))}
          </List>
        </div>
      </Popup>
    </div>
  )
}